// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-editor {
    margin-top: 20px;
    position: relative;
}

/* Block Options Dropdown */
.add-block-container {
    position: relative;
    z-index: 1;
}

.block-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 1000;
    margin-top: 8px;
    animation: slideDown 0.2s ease-out;
}

.block-options-header {
    padding: 16px 20px;
    border-bottom: 1px solid #e9ecef;
    background: #f8f9fa;
    border-radius: 8px 8px 0 0;
}

.block-options-header h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #495057;
}

.block-options-list {
    padding: 8px;
}

.block-option {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 12px;
}

.block-option:hover {
    background: #f8f9fa;
    transform: translateY(-1px);
}

.block-option span:first-child {
    font-size: 18px;
    color: var(--admin-color);
    width: 24px;
    text-align: center;
}

.block-option span:last-child {
    font-size: 14px;
    font-weight: 500;
    color: #495057;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.rich-text-editor-container {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.editor-toolbar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    border-radius: 8px 8px 0 0;
    gap: 8px;
    flex-wrap: wrap;
}

.toolbar-group {
    display: flex;
    align-items: center;
    gap: 4px;
}

.toolbar-divider {
    width: 1px;
    height: 24px;
    background: #dee2e6;
    margin: 0 8px;
}

.toolbar-btn {
    width: 32px;
    height: 32px;
    border: 1px solid transparent;
    background: transparent;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #495057;
    font-size: 14px;
}

.toolbar-btn:hover {
    background: #e9ecef;
    border-color: #dee2e6;
    color: var(--admin-color);
}

.toolbar-btn:active {
    background: #dee2e6;
    color: var(--admin-color);
}

.editor-content {
    padding: 20px;
    min-height: 300px;
}

.rich-text-editor {
    width: 100%;
    min-height: 300px;
    padding: 16px;
    border: none;
    outline: none;
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    background: transparent;
    resize: vertical;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.rich-text-editor:focus {
    outline: none;
}

.rich-text-editor:empty:before {
    content: attr(placeholder);
    color: #adb5bd;
    font-style: italic;
    pointer-events: none;
}

.rich-text-editor h1,
.rich-text-editor h2,
.rich-text-editor h3,
.rich-text-editor h4,
.rich-text-editor h5,
.rich-text-editor h6 {
    margin: 16px 0 8px 0;
    font-weight: 600;
}

.rich-text-editor p {
    margin: 8px 0;
}

.rich-text-editor ul,
.rich-text-editor ol {
    margin: 8px 0;
    padding-left: 24px;
}

.rich-text-editor li {
    margin: 4px 0;
}

.rich-text-editor blockquote {
    margin: 12px 0;
    padding-left: 16px;
    border-left: 4px solid var(--admin-color);
    font-style: italic;
    color: #6c757d;
}

.rich-text-editor a {
    color: var(--admin-color);
    text-decoration: underline;
}

.rich-text-editor strong {
    font-weight: 600;
}

.rich-text-editor em {
    font-style: italic;
}

.rich-text-editor u {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Blog/BlogEdit/BlogContentEditor.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,0BAA0B;IAC1B,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,8EAA8E;AAClF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;;;;IAMI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".content-editor {\n    margin-top: 20px;\n    position: relative;\n}\n\n/* Block Options Dropdown */\n.add-block-container {\n    position: relative;\n    z-index: 1;\n}\n\n.block-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    z-index: 1000;\n    margin-top: 8px;\n    animation: slideDown 0.2s ease-out;\n}\n\n.block-options-header {\n    padding: 16px 20px;\n    border-bottom: 1px solid #e9ecef;\n    background: #f8f9fa;\n    border-radius: 8px 8px 0 0;\n}\n\n.block-options-header h4 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #495057;\n}\n\n.block-options-list {\n    padding: 8px;\n}\n\n.block-option {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    gap: 12px;\n}\n\n.block-option:hover {\n    background: #f8f9fa;\n    transform: translateY(-1px);\n}\n\n.block-option span:first-child {\n    font-size: 18px;\n    color: var(--admin-color);\n    width: 24px;\n    text-align: center;\n}\n\n.block-option span:last-child {\n    font-size: 14px;\n    font-weight: 500;\n    color: #495057;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.rich-text-editor-container {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    background: white;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.editor-toolbar {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n    border-radius: 8px 8px 0 0;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.toolbar-group {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.toolbar-divider {\n    width: 1px;\n    height: 24px;\n    background: #dee2e6;\n    margin: 0 8px;\n}\n\n.toolbar-btn {\n    width: 32px;\n    height: 32px;\n    border: 1px solid transparent;\n    background: transparent;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: #495057;\n    font-size: 14px;\n}\n\n.toolbar-btn:hover {\n    background: #e9ecef;\n    border-color: #dee2e6;\n    color: var(--admin-color);\n}\n\n.toolbar-btn:active {\n    background: #dee2e6;\n    color: var(--admin-color);\n}\n\n.editor-content {\n    padding: 20px;\n    min-height: 300px;\n}\n\n.rich-text-editor {\n    width: 100%;\n    min-height: 300px;\n    padding: 16px;\n    border: none;\n    outline: none;\n    font-size: 16px;\n    line-height: 1.6;\n    color: #333;\n    background: transparent;\n    resize: vertical;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.rich-text-editor:focus {\n    outline: none;\n}\n\n.rich-text-editor:empty:before {\n    content: attr(placeholder);\n    color: #adb5bd;\n    font-style: italic;\n    pointer-events: none;\n}\n\n.rich-text-editor h1,\n.rich-text-editor h2,\n.rich-text-editor h3,\n.rich-text-editor h4,\n.rich-text-editor h5,\n.rich-text-editor h6 {\n    margin: 16px 0 8px 0;\n    font-weight: 600;\n}\n\n.rich-text-editor p {\n    margin: 8px 0;\n}\n\n.rich-text-editor ul,\n.rich-text-editor ol {\n    margin: 8px 0;\n    padding-left: 24px;\n}\n\n.rich-text-editor li {\n    margin: 4px 0;\n}\n\n.rich-text-editor blockquote {\n    margin: 12px 0;\n    padding-left: 16px;\n    border-left: 4px solid var(--admin-color);\n    font-style: italic;\n    color: #6c757d;\n}\n\n.rich-text-editor a {\n    color: var(--admin-color);\n    text-decoration: underline;\n}\n\n.rich-text-editor strong {\n    font-weight: 600;\n}\n\n.rich-text-editor em {\n    font-style: italic;\n}\n\n.rich-text-editor u {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
